var map = {
	"./help-centre/app.config.js": 9218,
	"./login/app.config.js": 2518,
	"./myaccount/app.config.js": 7118,
	"./players/app.config.js": 9042,
	"./search/app.config.js": 7239,
	"./store/app.config.js": 442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5595;